export default function setBrandConfig(brandConfig) {
  if (!brandConfig || !brandConfig.styles) return

  const { backgrounds, text, borders } = brandConfig.styles

  let styleString = ''

  // Background colors
  if (backgrounds) {
    backgrounds.forEach(item => {
      styleString += `.${item.className} { background-color: ${item.colour} !important; }\n`
    })
  }

  // Text colors
  if (text) {
    text.forEach(item => {
      styleString += `.${item.className} { color: ${item.colour} !important; }\n`
    })
  }

  // Border colors
  if (borders) {
    borders.forEach(item => {
      styleString += `.${item.className} { border-color: ${item.colour} !important; }\n`
    })
  }

  // Create and inject style element
  const styleElement = document.createElement('style')
  styleElement.id = 'brand-styles'
  styleElement.innerHTML = styleString

  // Remove existing brand styles if any
  const existingStyles = document.getElementById('brand-styles')
  if (existingStyles) {
    existingStyles.remove()
  }

  // Inject into document head
  document.head.appendChild(styleElement)

  // Also set CSS custom properties for easier access
  if (brandConfig.theme) {
    const root = document.documentElement
    root.style.setProperty('--primary-color', brandConfig.theme.primaryColor)
    root.style.setProperty('--secondary-color', brandConfig.theme.secondaryColor)
    root.style.setProperty('--accent-color', brandConfig.theme.accentColor)
  }
}
